// @flow
import React, {useMemo} from 'react';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';
import {makeStyles, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import CustomButtom from '../../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../../assets/styles/colors';
import {usePaymentMethods, useUpdateShippingMethodActive} from '../utils';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
    gap: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    fontSize: '1.375rem',
    TextAlign: 'center',
    width: '70%',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(2),

    '& button': {
      width: '90%',
    },
  },
  textSpan: {
    fontSize: '1rem',
    textAlign: 'center',
    color: colors.grey700,
  },
}));

type Props = {
  open: boolean,
  handleClose: () => void,
  setTypeRateSelected: (typeRate: string) => void,
  typeRateSelected: string, //'STANDARD' | 'FLAT_RATE' | 'ADVANCED' | 'MANUAL',
};

export default function ActivateRateModal(props: Props) {
  const {open, handleClose, setTypeRateSelected, typeRateSelected} = props;
  const {updateShippingMethodActive} = useUpdateShippingMethodActive();
  const paymentMethods = usePaymentMethods();
  const classes = useStyles();

  const handleCloseModal = () => {
    handleClose();
    setTypeRateSelected('');
  };

  const disableActivation = useMemo(() => {
    let found = false;
    if (paymentMethods && typeRateSelected === 'MANUAL') {
      paymentMethods.every(pm => {
        if (['CARD', 'OTHERS'].includes(pm.paymentMethod) && pm.enabled) {
          found = true;
          return false;
        }
        return true;
      });
      if (found) return true;
      else return false;
    }
  }, [paymentMethods, typeRateSelected]);

  const handleActivateTypeRate = () => {
    const formatTypeRateActive = {
      shippingMethodType: typeRateSelected,
    };

    updateShippingMethodActive(formatTypeRateActive);
    handleCloseModal();
  };

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <Typography align="center" gutterBottom className={classes.title}>
          ¿Está seguro que desea activar esta tarifa?
        </Typography>

        <div className={classes.container}>
          {typeRateSelected === 'MANUAL' && (
            <Typography className={classes.textSpan}>
              Nota: Este método de envío sólo es compatible con el método de
              pago "Pedir por Whatsapp"
            </Typography>
          )}
          <Typography className={classes.textSpan}>
            Una vez activada las demás se desactivarán.
          </Typography>
          <Typography className={classes.textSpan}>
            Recuerda que solo puede activar una tarifa a la vez
          </Typography>
        </div>

        <div className={classes.actions}>
          <CustomButtom
            variant="outlined"
            color="primary"
            onClick={handleClose}
          >
            Cancelar
          </CustomButtom>
          <CustomButtom
            variant="contained"
            color="primary"
            onClick={handleActivateTypeRate}
            disabled={disableActivation}
          >
            Confirmar
          </CustomButtom>
        </div>
      </div>
    </CustomModal>
  );
}

ActivateRateModal.propTypes = {
  open: PropTypes.bool,
  handleOpen: PropTypes.func,
  handleClose: PropTypes.func,
  setTypeRateSelected: PropTypes.func,
  typeRateSelected: PropTypes.string,
};
